import { useEffect } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "@/components/Logo";
import { useLang } from "@/lib/i18n";

export default function Intro() {
  const { t } = useLang();
  const lines = t("intro.lines");

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <motion.div
      data-testid="intro-overlay"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0B0C0E]"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="mb-10 flex items-center gap-3"
      >
        <LogoMark className="h-8 w-8" />
        <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-[#686D76]">
          Multigroupnetwork
        </span>
      </motion.div>

      <h2 className="px-4 text-center font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] text-[#EAE6E1]">
        {lines.map((line, i) => (
          <span key={line} className="block overflow-hidden pb-1">
            <motion.span
              data-testid={`intro-line-${i}`}
              className={`block ${i === 1 ? "text-[#8C9A86]" : ""}`}
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.85, delay: 0.3 + i * 0.18, ease: [0.22, 1, 0.36, 1] }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h2>

      <div className="absolute bottom-16 h-px w-40 overflow-hidden bg-[#262930]">
        <motion.div
          className="h-full bg-[#8C9A86]"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.7, delay: 0.3, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
}
